/* eslint eqeqeq: 'off' */ 
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

// GET Method for Zones,( Retrieve all zones available in Tracer Ensemble Tenant Services)

export function GetAllHolidays() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_Holidays).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.GET_HOLIDAY_LIST_SUCCESSFUL));
         }).catch(error => {
             throw error;
         })
     }
 }


// GET Method for Buildings,( Retrieve all Buildings available in Tracer Ensemble Tenant Services)

export function GetBuildingsList() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.get_Buildings_List).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined && response.length > 0)
              dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_LIST_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }

 export function GetBuildingsDetailsList() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Buildings_Details_List).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined && response.length > 0)
               dispatch(actionToStoreSuccess(response,types.GET_BUILDINGS_DETAILS_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

export function GetHolidayDetails(id) { 
    return function (dispatch) {
        return APIutil.GetDetailsByID(url.get_Holiday_By_ID,id).then(response => {  
            dispatch(global_error_handling(response));  
            dispatch(actionToStoreSuccess(response,types.GET_HOLIDAY_SUCCESSFUL));
        }).catch(error => {
            throw error;
        })
    }
}

export function SaveHoliday(data) { 
    return function (dispatch) {
        return APIutil.postData(url.get_Add_Holiday,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(GetAllHolidays());
        }).catch(error => {
            throw error;
        })
    }
}

//Update(put) Holiday
export function UpdateHoliday(data) { 
    return function (dispatch) {
        return APIutil.editDataAPI(url.put_Edit_Holiday + data.HolidayId,data).then(response => {
            dispatch(global_error_handling(response));  
        if(response.status == 200)
             dispatch(GetAllHolidays());
        }).catch(error => {
            throw error;
        })
    }
}

//Delete Method for deleting single or multiple holidays
export function DeleteHoliday(holidays_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.delete_Holidays,holidays_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));  
           if(response.status == 200)
               dispatch(GetAllHolidays());
        }).catch(error => {
            throw error;
        })
    }
}


/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking it type and updates the state. */

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}














